import { Component } from '@grafikr/components';
import fastdom from "fastdom";

export default Component((node) => {
  let hasScrolledPast = window.scrollY > window.innerHeight;

  const checkPos = () => {
    fastdom.measure(() => {
      hasScrolledPast = window.scrollY > window.innerHeight
    })

    fastdom.mutate(() => {
      if (hasScrolledPast) {
        node.classList.add('opacity-100')
        node.classList.remove('opacity-0', 'pointer-events-none')
      } else {
        node.classList.add('opacity-0', 'pointer-events-none')
        node.classList.remove('opacity-100')
      }
    })
  }

  window.addEventListener('scroll', checkPos);

  node.addEventListener('click', () => {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    })
  })
});
